import React, {Component, Fragment, createRef} from 'react';
import * as SignalR from '@aspnet/signalr';
import { v4 as uuidv4 } from 'uuid';

import '../chat.css';
import Setup from '../config/Setup'
import MessageType from '../config/constants/MessageTypeEnum'
import ChatBotChatField from './chatField/ChatBotChatField';
import ChatInput from './chatInput/ChatInput';
import ChatResponseFeedbackEnum from "../config/constants/ChatResponseFeedbackEnum";
import ChatQuestionTypeEnum from "../config/constants/ChatQuestionTypeEnum";
import LineBreakTypeEnum from "../config/constants/LineBreakTypeEnum";
import InfoPage from "./infoPage/InfoPage";
import axios from "axios";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Localization from "../config/localization/Localization";
import CircularProgress from "@material-ui/core/CircularProgress";
import {isMobile} from "react-device-detect";
import { getLocalizationLanguageCode } from "../util/localization";
import { getLanguageConfig } from "../util/utilMethods";
import LayoutTypeEnum from "../config/constants/LayoutTypeEnum";
import TopBar from "./topBar/TopBar";
import SearchBotChatField from "./chatField/searchBotChatField/SearchBotChatField";
import MarkdownIt from "markdown-it";
import markdownItCodeCopy from 'markdown-it-code-copy';

/**
 * Class for the chat.
 * Handles the signalR logic for sending and receiving messages.
 */
class Chat extends Component {
  constructor(props) {
    super(props);
    this.searchBotFieldRef = createRef();
    this.chatAttachmentRef = createRef();
    const searchParams = new URLSearchParams(this.props.location.search.toString());
    const chatbotOpenState = (searchParams.get("openState") === 'true');
    const intentId = searchParams.get("intentId");
    const languageParam = searchParams.get("language");
    const isPhone = searchParams.get("isPhone");
    const useArchivedData = (searchParams.get("useArchivedData") === 'true');

    const token = this.props.match.params.token;
    const userId = this.props.match.params.userId;
    const chatAgentMode = this.props.match.params.chatAgentMode ? true : false;
    const integrationType = this.props.match.params.integrationType ? parseInt(this.props.match.params.integrationType) : null;
    const domain = (document.referrer ?
        document.referrer.toLowerCase().split('/')[2].split(':')[0].trim()
        : (document.location.ancestorOrigins ?
            document.location.ancestorOrigins[0].toLowerCase().split('/')[2].split(':')[0].trim():null));
    const clientKey = this.props.match.params.clientKey;

    const debug = searchParams.get("debug") ?? false



    this.state = {
      botWriting: false,
      userWriting: false,
      speechBubbleList: [],
      hubConnection: null,
      connected: false,
      showConnectionLostMsg: false,
      token: token,
      languageParam: languageParam,
      language: this.props.match.params.languageData ? JSON.parse(decodeURIComponent(this.props.match.params.languageData)) : null,
      intentId: intentId,
      chatConfig: null,
      requestedWelcome: false,
      userId: userId,
      chatAgentMode: chatAgentMode,
      integrationType: integrationType,
      forceWelcomeMessage: false,
      startLoad: 0,
      loadMore: false,
      loadToEnd: true,
      showInfoPage: false,
      snackbarErrorMessage: null,
      chatbotOpenState: chatbotOpenState,
      useArchivedData: useArchivedData,
      hadFirstClick: false,
      welcomePreviewEnabled: false,
      clientKey: clientKey,
      domain: domain,
      debug: debug,
      isPhone: isPhone,
      disableConnectionRetry: false,
      trainingPhraseList: [],
      streamIdStopped: [],
      lastStreamId: null,
      isMaximized: false,
      speechBubbleBuffer :[],
      showStopMessage : false,

      isChatMinimized: true,
      chatInputMessage: '',
      showSearchBotChatField: false,
      chatFieldPlacement: 'top',
      openDownWards: null,
      pendingFileUrls: [],
      pendingFiles: [],
      fileUploadedList: [], // This keeps track of the visuals of the uploaded files.
      fileUploadedListRemove: null,
      fileUploadedText:false,
      fileUploading:false,
      retryAttempts:0,
      firstRetryTimestamp:null,
      sourcesList: []
    };

    // Event listener for outside iframe
    const iframeListener = (e) => {

      if (e.data.setchatbotOpenState != null) {
        this.setState({chatbotOpenState: e.data.setchatbotOpenState});

      } else if (e.data.setWelcomePreviewEnabled != null) {
        this.setState({welcomePreviewEnabled: e.data.setWelcomePreviewEnabled});
      }
    };

    try {
      if ('addEventListener' in window) {

        window.addEventListener('message', iframeListener);

      } else if ('attachEvent' in window) { //IE

        window.attachEvent('message', iframeListener);
      }
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Sends a SignalR message with one available retry after 3 seconds.
   */
  invokeSignalRMessage = (args) => {
    return this.state.hubConnection
        .invoke(...args)
        .catch(err => {
          console.error('Message failed, retrying...');

          setTimeout(() => {
            this.state.hubConnection
                .invoke(...args)
                .catch(err => {
                  console.error(err);
                });
          }, 3000);
        })
  };

  markText = (text) => {

    if(text == null)
    {
      return '';
    }

    var md = new MarkdownIt({
      linkify: true,
      html: true,
    }).use(markdownItCodeCopy, {
      iconStyle: "font-size: 21px; opacity: 0.4;",
      iconClass: "mdi content-copy",
      buttonStyle: 'position: absolute; top: 7.5px; right: 6px; cursor: pointer; outline: none;',
      buttonClass: ''
    });

    const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
      return self.renderToken(tokens, idx, options);
    };

    // Add target="_blank" to external links
    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
      const aIndex = tokens[idx].attrIndex('target');

      if (aIndex < 0) {
        tokens[idx].attrPush(['target', '_blank']); // add new attribute
      } else {
        tokens[idx].attrs[aIndex][1] = '_blank';    // replace value of existing attr
      }

      // Adding rel="noopener noreferrer"
      const relIndex = tokens[idx].attrIndex('rel');

      if (relIndex < 0) {
        tokens[idx].attrPush(['rel', 'noopener noreferrer']);
      } else {
        tokens[idx].attrs[relIndex][1] = 'noopener noreferrer';
      }

      const hrefIndex = tokens[idx].attrIndex('href');

      if (hrefIndex >= 0) {
        // Fjern parenteser i URL'en
        tokens[idx].attrs[hrefIndex][1] = tokens[idx].attrs[hrefIndex][1].replace(/\(|\)/g, '');
      }

      // pass token to default renderer.
      return defaultRender(tokens, idx, options, env, self);
    };

    let renderedText = md.render(text);
    // Remove the first <p> and the corresponding </p> if they exist
    if (renderedText.startsWith("<p>")) {
      renderedText = renderedText.substring(3);
    }
    if (renderedText.endsWith("</p>\n")) {
      renderedText = renderedText.substring(0, renderedText.length - 5);
    }

    return  renderedText;
  }

  setShowSearchBotChatField = (show) => {
    window.parent.postMessage({'showSearchBotChatField': show}, '*');

    this.setState({showSearchBotChatField: show})
  }

  loadMoreSpeechBubble = () => {
    this.setState({loadToEnd : false});
    this.invokeSignalRMessage(['SendChatHistory', this.state.language.id, this.state.startLoad, Setup.messageLoadCount, this.state.useArchivedData]);
  };

  sendMostAskedQuestions = (questions) => {
    this.invokeSignalRMessage(['SendMostAskedQuestions', this.state.language.id, this.state.startLoad, Setup.messageLoadCount, questions]);
  }

  setIsMenuTriggered = (value) => {
    this.setState({ isMenuTriggered: value });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.pendingFileUrls !== this.state.pendingFileUrls) {
      const uniquePendingFileUrls = [...new Set(this.state.pendingFileUrls)];
      if (uniquePendingFileUrls.length !== this.state.pendingFileUrls.length) {
        this.setState({ pendingFileUrls: uniquePendingFileUrls });
      }
    }

    if (prevState.fileUploadedList !== this.state.fileUploadedList) {
      if (this.state.fileUploadedList && this.state.fileUploadedList.length > 0) {
        this.setState({ fileUploadedText: true });}
      const uniqueFileUploadedList = [...new Set(this.state.fileUploadedList)];
      if (uniqueFileUploadedList.length !== this.state.fileUploadedList.length) {
        this.setState({ fileUploadedList: uniqueFileUploadedList });
      }
    }

    if (prevState.sourcesList !== this.state.sourcesList && this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot) {
      this.resizeSourceContainer(this.state.sourcesList);
    }
    if ((prevState.chatConfig !== this.state.chatConfig)) {
      this.setChatFieldPlacement();
    }
  }



  /**
   * On startup a connection is made to the SignalR hub and event listeners is set up.
   */
  componentDidMount = () => {
    // SignalR connection config.
    if (navigator.webdriver) {
      return;
    }

    const hubConnection = new SignalR.HubConnectionBuilder()
        .withUrl((process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) +
            'chat?token=' + this.state.token + '&userId=' + this.state.userId + '&chatAgentMode=' + this.state.chatAgentMode +
            '&clientKey=' + this.state.clientKey + '&domain=' + this.state.domain + '&isPhone=' + this.state.isPhone + 
            '&useArchivedData=' + this.state.useArchivedData+ '&debug=' + this.state.debug)
        .configureLogging(process.env.NODE_ENV === 'development' || process.env.REACT_APP_TEST_BUILD ? SignalR.LogLevel.Debug : SignalR.LogLevel.Error)
        .build();

    // Establishing connection to SignalR hub.
    this.setState({hubConnection}, () => {
      this.startChatConnection();



      // Event listener for when the connection is lost
      this.state.hubConnection.onclose((error) => {
        this.setState({connected: false}, () => {
          this.reConnectChatConnection();
        });
      });

      // Event listener for when the widget should disable retry
      this.state.hubConnection.on('DisableConnectionRetry', () => {
        this.setState({disableConnectionRetry: true});
        window.parent.postMessage({'hideChatbot': true}, '*');
      });

      // Event listener for when the chat config is recieved.
      this.state.hubConnection.on('ChatConfig', (chatConfig, token) => {
        this.setState({token});

        if(chatConfig.layoutMode === LayoutTypeEnum.searchBot)
        {
          window.parent.postMessage({'setSearchbotToken': token}, '*');
        }else
        {
          window.parent.postMessage({'setChatToken': token}, '*');
        }



        hubConnection.connection.baseUrl =  (process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) +
            'chat?token=' + token+ '&userId=' + this.state.userId + '&chatAgentMode=' + this.state.chatAgentMode +
            '&clientKey=' + this.state.clientKey + '&domain=' + this.state.domain + '&isPhone=' + this.state.isPhone + 
            '&useArchivedData=' + this.state.useArchivedData+ '&debug=' + this.state.debug;

        if (this.state.chatConfig) {
          return;
        }

        this.setState({chatConfig});

        let language = this.state.language;
        let languageParam = this.state.languageParam;

        // First try to read the language from query parameter.
        if (!language && languageParam) {
          //override e-gb to en - language
          if(languageParam.toLowerCase()  == "en-gb")
          {
            languageParam = "en";
          }
          language = chatConfig.chatConfigLanguageList.find((lang) => {
            return lang.language.languageCode.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.languageCodeShort.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.countryCode.toLowerCase() === languageParam.toLowerCase() ||
                lang.language.name.toLowerCase() === languageParam.toLowerCase();
          }).language;
        }

        // If no language found, set the first language in the chat config as selected.
        if (!language) {
          language = chatConfig.chatConfigLanguageList[0].language;
        }

        this.setState({language}, () => {
          if(!(this.state.userId == null && this.state.chatConfig.layoutMode !== null && this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot)){
            this.invokeSignalRMessage(['SendChatHistory', this.state.language.id, this.state.startLoad, Setup.messageLoadCount, this.state.useArchivedData]);
          }
        });

        // Inject client html, script and css
        const head = document.getElementsByTagName('head')[0];

        if (chatConfig.clientScript && this.state.userId == null) {
          const clientScriptElement = document.createElement('script');
          clientScriptElement.text = chatConfig.clientScript;

          head.appendChild(clientScriptElement);
        }

        if (chatConfig.clientCss) {
          const clientStyleElement = document.createElement('style');
          clientStyleElement.appendChild(document.createTextNode(chatConfig.clientCss));

          head.appendChild(clientStyleElement);
        }

        if (chatConfig.clientHeaderHtml) {

          const linkElement = document.createElement('link');
          linkElement.href = chatConfig.clientHeaderHtml;
          linkElement.rel = 'stylesheet';

          head.appendChild(linkElement);
        }

        if(chatConfig.soundOnMessageReceived) {
          var x = document.createElement("AUDIO");
          x.id = "audio_messagereceived";
          x.src = "/sound/" + chatConfig.messageReceivedSound;
          x.preload = "auto";
          document.body.appendChild(x);
        }

        if (this.state.chatConfig &&
            this.state.chatConfig.layoutMode !== null &&
            this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot) {
          this.setSearchBot();
          this.setChatFieldPlacement();
        }
        else{
          this.setChatBot();
        }

      });

      // Event listener for when user or chat agent starts or stop writing
      this.state.hubConnection.on('SendUserIsWriting', (isChatAgent, isWriting) => {
        if (isChatAgent) {
          this.setState({botWriting: isWriting});
        } else {
          this.setState({userWriting: isWriting});
        }
      });

      // Event listener for when messages are recieved.
      this.state.hubConnection.on('Send', (chatResponse) => {
        if (this.state.chatbotOpenState === false) {
          const showNewMsgIcon = isMobile ? this.state.chatConfig.showNewMsgIconMobile : this.state.chatConfig.showNewMsgIconDesktop;

          if (showNewMsgIcon) {
            window.parent.postMessage({'showNewMsgIcon': true}, '*');
          }
        }

        this.setState({loadToEnd: true});
        this.handleChatResponse(chatResponse);
      });

      this.state.hubConnection.on('SendSource', (chatResponse) => {

        let uniqueTuples = [...this.state.sourcesList];
        /*       console.log(speechBubbleList, "HER") */
        //Her skal du så hvert svar ^ lave et array eller noget, så du senere kan vise Link/Titel og et uddrag fra kilden
        if(chatResponse.speechBubbleList!=null && chatResponse.speechBubbleList.length> 0 ) {
          chatResponse.speechBubbleList.forEach((speechBubble) => {
            if (speechBubble.title !== "" && speechBubble.url !== "") {
              const exists = uniqueTuples.some(
                  ([title, url]) => title === speechBubble.title && url === speechBubble.url
              );

              if (!exists) {
                uniqueTuples.push([speechBubble.messageList
                    .map(message => this.markText(message.content))
                    .join('\n'),speechBubble.title, speechBubble.url]); // Add tuple to state array.
              }
            }
          });

          // Update state with unique tuples
          this.setState({ sourcesList: uniqueTuples });
        }

      });



      // Event listener when chat history is received
      this.state.hubConnection.on('SendChatHistory', (chatResponseListResult) => {
        let speechBubbleList = this.state.speechBubbleList;

        if(this.state.loadToEnd == false) {
          chatResponseListResult.item2= chatResponseListResult.item2.reverse();
        }

        chatResponseListResult.item2.forEach((chatResponse) => {
          if(this.state.loadToEnd == false)  {
            chatResponse.speechBubbleList=  chatResponse.speechBubbleList.reverse();
          }
          speechBubbleList = this.handleChatResponse(chatResponse, speechBubbleList);
        });

        const startLoadCalc = this.state.startLoad + chatResponseListResult.item2.length;
        const loadMoreCalc = startLoadCalc < chatResponseListResult.item1;

        this.setState({totalCount: chatResponseListResult.item1,startLoad: startLoadCalc, loadMore: loadMoreCalc});

        this.setState({speechBubbleList}, () => {
          if (this.state.requestedWelcome === false && this.state.userId == null) {
            if (this.state.intentId) {
              this.sendIntent(this.state.intentId, ChatQuestionTypeEnum.customIntent);
            } else {
              this.sendWelcome();
            }

            this.setState({requestedWelcome: true});
          }
        });

      });


      // Event listener when a user likes a message
      this.state.hubConnection.on('SendChatResponseFeedback', (chatQuestionId, chatResponseFeedback) => {
        let speechBubbleList = this.state.speechBubbleList;

        const speechBubbleIndex = speechBubbleList.findIndex(sb => sb.chatQuestionId === chatQuestionId);
        if (speechBubbleIndex !== -1) {
          speechBubbleList[speechBubbleIndex].chatResponseFeedback = chatResponseFeedback;

          this.setState({speechBubbleList});
        }
      });

      // Event listener for when mail is sent.
      this.state.hubConnection.on('SendEmail', () => {
        this.setState({botWriting: false});

        let speechBubbleList = this.state.speechBubbleList;

        speechBubbleList.forEach((speechBubble) => {
          if (speechBubble.isMailResponse) {
            speechBubble.hidden = false;
          }
        });

        this.setState({speechBubbleList});
      });

      this.state.hubConnection.on('SendTrainingPhraseList', (trainingPhraseList) => {
        this.setState({trainingPhraseList: trainingPhraseList });
      });
    });

  };

  toggleChatbot = () => {
    this.setState((prevState) => ({
      isChatMinimized: !prevState.isChatMinimized
    }));
  };

  handleMenuItemClick = (menuItem) => {

     const speechBubbleToDisplay = this.getMessageSpeechBubble(menuItem.displayName);

    this.setBotIsWriting();

    if(this.state.chatConfig.layoutMode !== null && this.state.chatConfig.layoutMode === LayoutTypeEnum.chatBot){
      this.appendSendMessage(speechBubbleToDisplay);
    }else {
      this.setState({ 
        chatInputMessage: menuItem.displayName,
        intent: menuItem,
        isMenuTriggered: true
       });
    }

  };

  handleResetUploadedFiles = () => {
    this.setState({fileUploadedList:[]})
  }

  handleAddUploadedFiles = (newFile) => {
    this.setState(prevState => {

      const fileExists = prevState.fileUploadedList.some(file => file === newFile);
      if (fileExists) {
        return null;
      }

      return {
        fileUploadedList: [...prevState.fileUploadedList, newFile]
      };
    });
  }

  handleDeleteUploadedFile = (fileName) => {
    this.setState((prevState) => {
      const updatedFileUploadedList = prevState.fileUploadedList.filter(file => file !== fileName);
      const updatedPendingFiles = prevState.pendingFiles.filter(file => !file.name.includes(fileName));

      return {
        fileUploadedList: updatedFileUploadedList,
        pendingFiles: updatedPendingFiles
      };
    }, () => {
      this.setState((prevState) => ({
        fileUploadedText: prevState.fileUploadedList.length > 0
      }));
    });
  };


  handleFlushDeleteUploadedFile = () => {
    this.setState({fileUploadedListRemove: null})
    if (this.state.fileUploadedList && this.state.fileUploadedList.length > 0) {
      this.setState({ fileUploadedText: true });
    } else {
      this.setState({ fileUploadedText: false });
    }
  }

  handleDeletePendingFile = (fileName) => {
    this.setState(prevState => ({
      fileUploadedList: prevState.fileUploadedList.filter(file => file !== fileName),
      pendingFiles: prevState.pendingFiles.filter(file => !file.name.includes(fileName)),
    }));
  };



  handleChatResponse = (chatResponse, speechBubbleList) => {

    if(chatResponse.isStream == true  )
    {
      speechBubbleList = this.state.speechBubbleList;
      let uniqueTuples = Array.isArray(this.state.sourcesList) ? [...this.state.sourcesList] : [];
      /*       console.log(speechBubbleList, "HER") */
      //Her skal du så hvert svar ^ lave et array eller noget, så du senere kan vise Link/Titel og et uddrag fra kilden
      if(speechBubbleList!=null && speechBubbleList.length> 0 ) {
        speechBubbleList.forEach((speechBubble) => {
          if (speechBubble.title !== "" && speechBubble.url !== "") {
            const exists = uniqueTuples.some(
                ([title, url]) => title === speechBubble.title && url === speechBubble.url
            );

            if (!exists) {
              uniqueTuples.push([speechBubble.title, speechBubble.url]); // Add tuple to state array.
            }
          }
        });

        // Update state with unique tuples
        this.setState({ sourcesList: uniqueTuples });




        // --- SPECIAL RULE: single-chunk stream (index === 1 && isLastStream) ---
        const firstChunk = chatResponse.speechBubbleList?.[0];
        if (firstChunk && firstChunk.index === 1 && firstChunk.isLastStream === true) {
          const streamId = firstChunk.streamId;

          // undgå dobbelt-visning hvis vi allerede har stoppet denne stream
          if (this.state.streamIdStopped.some(x => x === streamId)) {
            return this.state.speechBubbleList;
          }

          // vælg tekst fra contentSource først (streaming leverer her)
          const msg = firstChunk.messageList?.[0] || {};
          const raw = (msg.contentSource ?? msg.content) || '';
          const rendered = this.markText(raw);

          // hvis sidste boble allerede er en botboble for samme stream, så opdatér den
          let speechBubbleListLocal = this.state.speechBubbleList.slice();
          let last = speechBubbleListLocal[speechBubbleListLocal.length - 1];
          if (
              last &&
              (last.isUser === undefined || last.isUser === false) &&
              last.streamId === streamId
          ) {
            last.messageList[0].contentSource = raw;
            last.messageList[0].content = rendered;
            last.isLastStream = true;
            last.index = 1;
          } else {
            // ellers tilføj en ny, færdig bot-boble
            speechBubbleListLocal.push({
              ...firstChunk,
              isUser: false,
              isLastStream: true,
              index: 1,
              messageList: [
                {
                  ...msg,
                  contentSource: raw,
                  content: rendered
                }
              ]
            });
          }

          // markér stream som afsluttet, og stop "bot skriver…"
          const streamIdStopped = [...this.state.streamIdStopped, streamId];
          this.setState({
            speechBubbleList: speechBubbleListLocal,
            streamIdStopped,
            lastStreamId: streamId,
            showStopMessage: false,
            botWriting: this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot ? false : false
          });

          return speechBubbleListLocal; // vigtigt: vi er færdige i denne gren
        }
// --- END SPECIAL RULE ---

        const streamId = chatResponse.speechBubbleList[0].streamId;

        if(this.state.streamIdStopped.some((x) => x  == streamId) )
        {
          return ;
        }

        if(chatResponse.speechBubbleList[0].index > 1) {

          let speechBubbleBuffer = this.state.speechBubbleBuffer;

          speechBubbleBuffer.push(chatResponse.speechBubbleList[0]);

          speechBubbleBuffer = speechBubbleBuffer.sort((a, b) => a.index - b.index);

          let lastSpeechBubble =  speechBubbleList[speechBubbleList.length - 1];

          speechBubbleBuffer.forEach((item, index) => {

            lastSpeechBubble.index = (lastSpeechBubble.index == undefined || lastSpeechBubble.index == 0 ? 1 : lastSpeechBubble.index);

            const indexDiff = item.index - lastSpeechBubble.index;

            if (lastSpeechBubble && (lastSpeechBubble.isUser == undefined || lastSpeechBubble.isUser == false) && lastSpeechBubble.streamId == streamId && (indexDiff == 1) && item.isLastStream == false) {


              const lastSpeechBubbleMsg = lastSpeechBubble.messageList[0];
              const currentSpeechBubbleMsg = item.messageList[0];
              const speechBubbleContent = (lastSpeechBubbleMsg.contentSource ? lastSpeechBubbleMsg.contentSource : lastSpeechBubbleMsg.content) + (currentSpeechBubbleMsg.contentSource ? currentSpeechBubbleMsg.contentSource : currentSpeechBubbleMsg.content);
              speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource = speechBubbleContent;
              speechBubbleList[speechBubbleList.length - 1].messageList[0].content = this.markText(speechBubbleContent);
              speechBubbleList[speechBubbleList.length - 1].index = item.index;
              speechBubbleList[speechBubbleList.length - 1].isLastStream = item.isLastStream;
              speechBubbleBuffer = speechBubbleBuffer.filter(bufferItem => bufferItem.index !== item.index);

            }

          });

          let showStopMessage = true;

          if(chatResponse.speechBubbleList[0].isLastStream)
          {
            const currentSpeechBubbleContent =  chatResponse.speechBubbleList[0].messageList[0].content;
            speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource = currentSpeechBubbleContent;
            speechBubbleList[speechBubbleList.length - 1].messageList[0].content = this.markText(currentSpeechBubbleContent);
            speechBubbleList[speechBubbleList.length - 1].isLastStream = true;

            let streamIdStopped = this.state.streamIdStopped;

            streamIdStopped.push(chatResponse.speechBubbleList[0].streamId);

            showStopMessage = false;

            this.setState({streamIdStopped});
          }

          var botWritingStream = speechBubbleList[speechBubbleList.length - 1].isLastStream  ||  speechBubbleList[speechBubbleList.length - 1].messageList[0].contentSource == undefined ? false: true

          this.setState({
            speechBubbleList: speechBubbleList,
            speechBubbleBuffer: speechBubbleBuffer,
            lastStreamId: streamId,
            showStopMessage,
            botWriting: this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot ? false: botWritingStream
          });

          return;
        }


      }

    }

    let delay = 0;


    const lastNonSuggestionSpeechBubbleIndex = chatResponse.speechBubbleList.map((speechBubble) => {
      return speechBubble.suggestion;
    }).lastIndexOf(null);

    //Id used in internal sorting for search bot layout
    const chatResponseDropId = uuidv4();

    chatResponse.speechBubbleList.forEach((speechBubble, i, array) => {
      // If any delay on speechbubble a 'is writing animation' speechbubble is shown.

      if (speechBubble.delay) {
        delay += speechBubble.delay;
        let botWriting = true;
        this.setState({botWriting});
      }

      if(this.state.loadToEnd == false)
      {
        if (speechBubble.suggestion) {
          speechBubble.hidden = true;
        }
      }

      speechBubble.dropId = chatResponseDropId;
      speechBubble.chatResponseId = chatResponse.id;
      speechBubble.integrationType = chatResponse.integrationType;

      speechBubble.index = i;

      if (!(this.state.chatConfig &&
          this.state.chatConfig.layoutMode !== null &&
          this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot)) {
        speechBubble.dateTimeUtc = chatResponse.dateTimeUtc;
      }


      // Sets if chat rating buttons should be shown.
      if (chatResponse.chatQuestionId &&
          speechBubble.index === lastNonSuggestionSpeechBubbleIndex &&
          !speechBubble.isUser &&
          speechBubble.lineBreakType !== LineBreakTypeEnum.carousel) {

        speechBubble.chatQuestionId = chatResponse.chatQuestionId;
        speechBubble.chatResponseFeedback = chatResponse.chatResponseFeedback;
      }

      if (speechBubble.index > 0) {
        speechBubble.index -= array.some(speechBubble => speechBubble.isUser) ? 1 : 0;
      }

      // Disables suggestions if in spectatormode.
      if (speechBubble.suggestion && this.state.userId) {
        speechBubble.disabled = true;
      }

      speechBubble.messageList = speechBubble.messageList.map(message => {
        return { ...message, content: this.markText(message.content) };
      });

      // If state should be updated.
      if (speechBubbleList) {
        if(this.state.loadToEnd) {
          speechBubbleList.push(speechBubble);
        } else
        {
          if(speechBubbleList.find(x=>x.chatQuestionId ==speechBubble.chatQuestionId) == undefined|| speechBubble.id=='00000000-0000-0000-0000-000000000000' || speechBubble.chatQuestionId == null) {
            speechBubbleList.unshift(speechBubble);
          }
        }
      } else {
        // Sets delay on when to show the speechbubble.
        setTimeout(() => {
          speechBubbleList = this.state.speechBubbleList;

          // Hide suggestions if user speechbubble is recieved.
          if (speechBubble.isUser || this.state.loadToEnd == false) {
            speechBubbleList.forEach((sb) => {
              if (sb.suggestion) {
                sb.hidden = true;
              }
            });
          }

          if(this.state.loadToEnd) {
            speechBubbleList.push(speechBubble);
          }else
          {
            if(speechBubbleList.find(x=>x.chatQuestionId ==speechBubble.chatQuestionId) == undefined|| speechBubble.id=='00000000-0000-0000-0000-000000000000' || speechBubble.chatQuestionId == null) {
              speechBubbleList.unshift(speechBubble);
            }
          }

          this.setState({speechBubbleList});

          if (i === array.length - 1 ) {
            let botWriting = false;
            this.setState({botWriting});
          }

        }, delay);

        if(this.state.chatConfig.soundOnMessageReceived && chatResponse.speechBubbleList && chatResponse.speechBubbleList[0] && chatResponse.speechBubbleList[0].avatarName) {
          setTimeout(() => {
            console.log("Play sound: Chat message received (delay = " + speechBubble.delay + ")");
            this.playReceivedMessageSound();
          }, speechBubble.delay);
        }

        // Open chatbot if message is recieved from chat agent.
        if (!this.state.userId && chatResponse && chatResponse.intentId === null) {
          window.parent.postMessage({'openChatbot': true}, '*');
        }
      }
    });



    // close chatbot , action close
    if (!this.state.userId && chatResponse && chatResponse.closeChatbot) {
      window.parent.postMessage({'closeChatbot': true}, '*');
    }


    if (this.state.chatConfig &&
        this.state.chatConfig.layoutMode !== null &&
        this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot) {

      if (speechBubbleList && speechBubbleList.length > 0 ) {
        // Check WithMemory flag to determine whether to keep all speech bubbles or just the last one
        if (!this.state.chatConfig.withMemory) {
          speechBubbleList = [speechBubbleList[speechBubbleList.length - 1]];
        }

        this.setState({ speechBubbleList });
      }
    }

    return speechBubbleList;
  };

  playReceivedMessageSound = () => {
    var audio = document.getElementById("audio_messagereceived");
    audio.play();
  }

  reConnectChatConnection = () => {

    if (this.state.connected === true) {
      return;
    }

    this.state.retryAttempts = (  this.state.retryAttempts || 0) + 1;

    if (!this.state.firstRetryTimestamp) {
      this.state.firstRetryTimestamp = Date.now();
    }

    const maxRetryDuration =  5 * 60 * 1000; // 5 minutes

    if (Date.now() - this.state.firstRetryTimestamp > maxRetryDuration) {
      console.log("Reconnect then stop");
      return;
    }

    const baseDelay = Setup.signalrConnectionRetryInterval;
    const maxDelay = 60000;

    const delay = Math.min(baseDelay * Math.pow(2, this.state.retryAttempts), maxDelay);

    setTimeout(() => {
      this.startChatConnection();
    }, delay);

  }

  startChatConnection = () => {

    if (this.state.connected === true || this.state.disableConnectionRetry) {
      return;
    }
    this.state.hubConnection.start()
        .then(() => {
          this.setState({
            connected: true,
            showConnectionLostMsg: false,
            retryAttempts: 0,
            firstRetryTimestamp: null
          });

        }).catch(() => {
      this.reConnectChatConnection();
    });
  };


  getMessageSpeechBubble = (message) => {
    return {
      isUser: true,
      messageList: [
        {
          messageType:  MessageType.text,
          content: message,
        }
      ]
    };
  };

  //
  updateStateOfPlaceholder=()=>{
    this.setState({fileUploadedText:false});
  }
  getFileMessageSpeechBubble = (filename, url) => {
    return {
      isUser: true,
      displayBackground: false,
      messageList: [
        {
          messageType: MessageType.file,
          filename:filename,
          url: url,
          lineBreak: 1
        }
      ]
    };
  };

  sendWelcome = () => {
    this.invokeSignalRMessage(['SendWelcome', this.state.language.languageCode, this.state.forceWelcomeMessage]);
    this.setState({forceWelcomeMessage: false});
  };

  sendUserIsWriting = (isWriting) => {
    this.invokeSignalRMessage(['SendUserIsWriting', isWriting]);
  };

  appendSendMessage = (speechBubble) => {
    

    this.setState({loadToEnd:true});

    let speechBubbleList = this.state.speechBubbleList;
    
    speechBubble.messageList = speechBubble.messageList.map(message => {
      return { ...message, content: this.markText(message.content) };
    });

    if(this.state.lastStreamId!=null)
    {
      let streamIdStopped = this.state.streamIdStopped

      streamIdStopped.push(this.state.lastStreamId);

      this.setState({streamIdStopped});
    }

    // Hides suggestions
    speechBubbleList.forEach((speechBubble) => {
      if (speechBubble.suggestion) {
        speechBubble.hidden = true;
      }
    });

    // Shows a message to the user that looks like they sent it.
    if (speechBubble && !(this.state.chatConfig.layoutMode !== null && this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot && this.state.chatConfig.withMemory === false)) {
      speechBubble.lineBreakType = LineBreakTypeEnum.newLine;
      if (this.state.chatAgentMode === true) {
        if (!speechBubbleList.some(msg => msg.content === speechBubble.content)) {
          speechBubbleList.push(speechBubble);
        }
      } else {
        speechBubbleList.push(speechBubble);
      }
    }

    this.setState({speechBubbleList});
  };

  stopMessage = () => {

    let streamIdStopped = this.state.streamIdStopped;

    if (!streamIdStopped.includes(this.state.lastStreamId)) {
      streamIdStopped.push(this.state.lastStreamId);
      this.setState({ streamIdStopped, botWriting: false });
    }

    this.setState({ showStopMessage: false });

  }

  setBotIsWriting = () => {
    this.setState({ botWriting: true });
  }

  handleAddPendingFiles = (newFile) => {
    this.setState(prevState => {
      const updatedPendingFiles = prevState.pendingFiles.filter(file => file.name !== newFile.name);
      return {
        pendingFiles: [...updatedPendingFiles, newFile]
      };
    });
  }


  flushPendingFiles = () => {
    this.setState({pendingFiles: []})
  }

  sendFiles = () => {
    const { pendingFiles } = this.state;


    // Convert each file upload to a Promise
    const uploadPromises = pendingFiles.map((file) => {
      return new Promise((resolve, reject) => {
        this.uploadFileComplete(file, this.props.match.params.token, (error) => {
          if (error) {
            console.error(`Error uploading file ${file.name}:`, error);
            reject(error);
          } else {
            resolve();
          }
        });
      });
    });

    return Promise.all(uploadPromises)
        .then(() => {
          this.setState({ pendingFiles: [], fileUploading: false });
          this.handleResetUploadedFiles();
        })
        .catch((error) => {
          console.error("Error in file uploads:", error);
          this.setState({ fileUploading: false });
        });
  };

  /**
   * Gets called when a message is sent from the webclient.
   */

  sendMessage = async (message, messageToDisplay, urls) => {
    if (this.state.connected === false) {

      await this.startChatConnection();

      await new Promise(resolve => setTimeout(resolve, 1500));

      if (this.state.connected === false) {
        this.setState({showConnectionLostMsg: true});
        this.flushTrainingPhraseList();
        return false;
      }
    }

    if(this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot){
      this.resizeContainerSend([]);
    }

    // Call resetChatMenuItems before sending the message
    if (this.searchBotFieldRef.current) {
      this.searchBotFieldRef.current.resetChatMenuItems();
    }

    try {

        this.setBotIsWriting();

      // Existing sendMessage logic
      const speechBubbleToDisplay = urls
          ? this.getFileMessageSpeechBubble(messageToDisplay, urls)
          : this.getMessageSpeechBubble(messageToDisplay);

      if(this.state.chatConfig.layoutMode === LayoutTypeEnum.chatBot || this.state.chatConfig.withMemory){
        this.appendSendMessage(speechBubbleToDisplay);
      }

      // Wait for pending files to be uploaded before proceeding
      await this.sendFiles();


      this.invokeSignalRMessage([
        'Send',
        message,
        this.state.language.languageCode,
        this.state.pendingFileUrls,
        this.state.lastStreamId
      ]);
      this.openChatContainer();
      this.setState({ sourcesList: [] });
      this.setState({ pendingFileUrls: [] });

      return true;
    } catch (error) {
      console.error('Error uploading files:', error);
      return false;
    }
  };


  sendIntent = async (intentId, chatQuestionType, messageToDisplay, speechBubble, hideSuggestions, chatMenuItemId) => {

    if (this.state.connected === false) {

      await this.startChatConnection();

      await new Promise(resolve => setTimeout(resolve, 1500));

      this.setState({showConnectionLostMsg: true});
      return;
    }

      this.setBotIsWriting();

      this.setState({loadToEnd: true});

      let speechBubbleToDisplay;

      // Clone speechbubble and show as the user send it.
      if (speechBubble) {
        speechBubbleToDisplay = JSON.parse(JSON.stringify(speechBubble));
        speechBubbleToDisplay.isUser = true;
        speechBubbleToDisplay.index = 0;
        speechBubbleToDisplay.chatResponseId = null;
        speechBubbleToDisplay.suggestion = null;
      } else if (messageToDisplay) {
        speechBubbleToDisplay = this.getMessageSpeechBubble(messageToDisplay);
      }

      this.appendSendMessage(speechBubbleToDisplay);

      // Sends either id of suggestion or chat menu item clicked or null.
      let key = null;
      if (chatQuestionType === ChatQuestionTypeEnum.suggestion) {
        key = speechBubble.suggestion.id;
      } else if (chatQuestionType === ChatQuestionTypeEnum.menuItem) {
        key = chatMenuItemId;
      }


      this.invokeSignalRMessage(['SendIntent', intentId, this.state.language.languageCode, chatQuestionType, key, speechBubbleToDisplay]);



  };

  sendChatAgentIntent = (intentId) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return false;
    }
    this.invokeSignalRMessage(['SendIntent', intentId, this.state.language.languageCode, ChatQuestionTypeEnum.customIntent, null, null]);
    return true;
  };

  sendChatResponseFeedback = (chatQuestionId, chatResponseFeedback) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }

    let speechBubbleList = this.state.speechBubbleList;
    let speechBubble = speechBubbleList.find((sb => {
      return sb.chatQuestionId === chatQuestionId;
    }));

    if (speechBubble) {
      speechBubble.chatResponseFeedback = chatResponseFeedback === ChatResponseFeedbackEnum.notSet ? null : chatResponseFeedback;
    }

    this.setState({speechBubbleList}, () => {
      this.invokeSignalRMessage(['SendChatResponseFeedback', chatQuestionId, chatResponseFeedback]);
    });
  };

  languageSelected = (countryCode) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return false;
    }

    const language = this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language).find((lang) => {
      return lang.countryCode === countryCode;
    });

    window.parent.postMessage({'languageSelected': language.languageCode}, '*');

    if (this.state.chatConfig.layoutMode === LayoutTypeEnum.chatBot) {

      this.setState({
        language,
        requestedWelcome: false,
        forceWelcomeMessage: true,
        speechBubbleList: [],
        startLoad: 0,
        trainingPhraseSuggestionList: []
      }, () => {
        this.invokeSignalRMessage(['SendChatHistory', this.state.language.id, this.state.startLoad, Setup.messageLoadCount, this.state.useArchivedData]);
      });
    } else {
      this.setState({language}, () => {
        if (this.searchBotFieldRef && this.searchBotFieldRef.current) {
          this.searchBotFieldRef.current.initializeChatMenuItems(true);
        }
      });
    }

    return true;
  };

  clearSpeechBubble = () => {

    this.setState({speechBubbleList: [], sourcesList:[]})
  }
  getTrainingPhraseList = (searchText) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }
    this.invokeSignalRMessage(['GetTrainingPhraseList', searchText, this.state.language.languageCode]);
  };

  getChatResponse = (intentId) => {
    if (this.state.connected === false) {
      this.setState({showConnectionLostMsg: true});
      return;
    }

    return this.invokeSignalRMessage(['GetChatResponse', intentId, this.state.language.languageCode]);
  };

  uploadFileComplete(file, token, callback) {

    return axios
        .post((process.env.NODE_ENV === 'development' ? Setup.apiEndpointDev : process.env.REACT_APP_TEST_BUILD ? Setup.apiEndpointTest : Setup.apiEndpointProd) + 'storage/upload/clientKey/' + this.state.clientKey , {file})
        .then(response => {
          this.sendUserIsWriting(false);
          this.setState(this.state.chatAgentMode ? {botWriting: false} : {userWriting: false});
          /* this.sendMessage(file.name, file.name, response.data) */

          this.setState((prevState) => ({
            pendingFileUrls: [...(prevState.pendingFileUrls || []), response.data], // Initialize if undefined
          }));

          callback();
        })
        .catch(error => {
          this.setSnackbarErrorMessage(Localization[getLocalizationLanguageCode(this.state.language ? this.state.language.languageCode : null)]['chatInput.chatAttachment.uploadFileError']);
          this.sendUserIsWriting(false);
          this.setState(this.state.chatAgentMode ? {botWriting: false} : {userWriting: false});
          callback();
        })
  }

  toggleShowInfoPage = () => {
    this.setState({showInfoPage: !this.state.showInfoPage});
  };

  closeChatbot = () => {

    this.setState({isMaximized: false});
    window.parent.postMessage({'closeChatbot': true}, '*');

  };

  openChatContainer = () => {
    window.parent.postMessage({'openChatContainer': true}, '*');
  };

  resizeChatContainer = (entries) => {
    window.parent.postMessage({'resizeChatContainer': entries}, '*');
  }

  setSearchBot = () => {
    window.parent.postMessage({'setSearchBot' : true}, '*')
  }

  setChatFieldPlacement = () => {
    window.parent.postMessage({ setChatFieldPlacement: this.state.chatConfig.openDownwards }, '*');
    if (this.state.chatConfig.openDownwards) {
      const searchBotLayoutElem = document.getElementById('search-bot-layout');
      if (searchBotLayoutElem) {
        // Remove any inline bottom and force top: 0
        searchBotLayoutElem.style.setProperty('bottom', 'auto', 'important');
        searchBotLayoutElem.style.setProperty('top', '0', 'important');
      }
    }
  };

  setChatBot = () => {
    window.parent.postMessage({'setChatBot' : true}, '*')
  }

  toggleMaxiChatbot = () => {
    window.parent.postMessage({'toggleMaxiChatbot': true}, '*');

    this.setState({isMaximized: !this.state.isMaximized});
  };

  resizeSourceContainer = (entries) => {
    const length = entries.length
    window.parent.postMessage({'resizeSourceContainer': length}, '*')
  }

  resizeContainerSend = (entries) => {
    const length = entries.length
    window.parent.postMessage({'resizeContainerSend': length}, '*')
  }

  setSnackbarErrorMessage = (errorMessage) => {
    this.setState({snackbarErrorMessage: errorMessage});
  };

  reEnableMostAskedQuestions = () => {
    window.parent.postMessage({'resetSearchBotWindow': true}, '*');
    if (this.searchBotFieldRef && this.searchBotFieldRef.current) {
      this.searchBotFieldRef.current.initializeChatMenuItems(true);
    }
  };

  disableMostAskedQuestions = () => {
    window.parent.postMessage({'resetSearchBotWindow': false}, '*');
    if (this.searchBotFieldRef && this.searchBotFieldRef.current) {
      this.searchBotFieldRef.current.initializeChatMenuItems(false);
    }
  };

  handleRootClick = () => {
    if (this.state.hadFirstClick === false) {

      if (this.state.welcomePreviewEnabled) {
        window.parent.postMessage({'disableWelcomePreview': true}, '*');
        this.setState({welcomePreviewEnabled: false});
      }

      this.setState({hadFirstClick: true});
    }
  };

  flushTrainingPhraseList = () => {
    this.setState({trainingPhraseList: []})
  }

  render() {

    const chatFieldSpectatorStyle = {
      width: '100%',
      maxWidth: '100%'
    };

    const currentLanguage = this.state.chatConfig && this.state.language ? 
      this.state.chatConfig.chatConfigLanguageList.find(ccl => ccl.language.id === this.state.language.id) :
      getLanguageConfig(this.state.chatConfig, this.state.languageParam);

    return (
        <div id={'chat-container'} onClick={this.handleRootClick}>

          {this.state.chatConfig ?
              <Fragment>
                <Snackbar
                    anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                    key={`${{vertical: 'top'}},${{horizontal: 'right'}}`}
                    open={this.state.snackbarErrorMessage}
                    onClose={() => { this.setSnackbarErrorMessage(null); }}
                    autoHideDuration={3000}
                    style={{top: '75px'}}
                >
                  <MuiAlert elevation={6} variant="filled" severity="error" onClose={() => { this.setSnackbarErrorMessage(null); }}>
                    {this.state.snackbarErrorMessage}
                  </MuiAlert>
                </Snackbar>

                <InfoPage language={this.state.language}
                          sendIntent={this.sendIntent}
                          chatConfig={this.state.chatConfig}
                          font={this.state.chatConfig && this.state.chatConfig.font}
                          color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                          backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                          gdprLink={this.state.chatConfig && this.state.chatConfig.gdprLink}
                          showInfoPage={this.state.showInfoPage}
                          toggleShowInfoPage={this.toggleShowInfoPage}
                          onMenuItemClick={this.handleMenuItemClick}
                />

                {this.state.userId == null && this.state.chatConfig.layoutMode !== null && this.state.chatConfig.layoutMode === LayoutTypeEnum.searchBot ?
                    <div id={'search-bot-layout'}>
                      <div id={'top-bar-search-bot-container'} style={{display: this.props.welcomePreviewEnabled ? 'none' : null}}>
                        <TopBar  layoutMode={this.state.chatConfig.layoutMode} language={this.state.language} showInfo ={this.state.chatConfig && !this.state.chatConfig.showLogoTop}
                                 avatar ={this.state.chatConfig && this.state.chatConfig.logoUrl} name={this.state.chatConfig && this.state.chatConfig.chatbotName}
                                 font={this.state.chatConfig && this.state.chatConfig.font}
                                 color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                                 backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                                 languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                     this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                 languageSelected={this.languageSelected} clientDescription={ this.state.chatConfig && this.state.chatConfig.clientDescription}
                                 enableMaximize={this.state.chatConfig.enableMaximize}  isMaximized ={this.state.isMaximized}  toggleMaxiChatbot ={this.toggleMaxiChatbot} closeChatbot ={this.closeChatbot}  toggleShowInfoPage={this.toggleShowInfoPage} welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                        />
                      </div>
                      {!this.state.chatConfig.openDownwards ? (
                          <>
                            <SearchBotChatField
                                token={this.state.token}
                                loadMore={this.state.loadMore}
                                loadToEnd={this.state.loadToEnd}
                                loadMoreSpeechBubble={this.loadMoreSpeechBubble}
                                speechBubbleList={this.state.speechBubbleList}
                                botWriting={this.state.botWriting}
                                userWriting={this.state.userWriting}
                                chatConfig={this.state.chatConfig}
                                sendMessage={this.sendMessage}
                                sendIntent={this.sendIntent}
                                welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                                sendChatResponseFeedback={this.sendChatResponseFeedback}
                                spectatorMode={this.state.userId != null}
                                language={this.state.language}
                                currentLanguage={currentLanguage}
                                onMenuItemClick={this.handleMenuItemClick}
                                sendMostAskedQuestions={this.sendMostAskedQuestions}
                                ref={this.searchBotFieldRef}
                                resizeChatContainer={this.resizeChatContainer}
                                sourcesList={this.state.sourcesList}
                                languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                    this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                languageSelected={this.languageSelected}
                                showSearchBotChatField={this.state.showSearchBotChatField}
                                toggleShowInfoPage ={this.toggleShowInfoPage}
                                setShowSearchBotChatField={(show) => this.setShowSearchBotChatField(show)}
                            />  <ChatInput
                              uploadFileComplete={(file, callback) =>
                                  this.uploadFileComplete(file, this.state.token, callback)
                              }
                              handleGetTrainingPhraseList={(text) => this.getTrainingPhraseList(text)}
                              handleGetChatResponse={(intentId) => this.getChatResponse(intentId)}
                              trainingPhraseList={this.state.trainingPhraseList}
                              botWriting={this.state.botWriting}
                              userWriting={this.state.userWriting}
                              chatConfig={this.state.chatConfig}
                              language={this.state.language}
                              sendMessage={this.sendMessage}
                              speechBubbleList = {this.state.speechBubbleList}
                              sendIntent={this.sendIntent}
                              stopMessage={this.stopMessage}
                              showStopMessage={
                                  this.state.chatConfig &&
                                  this.state.chatConfig.gptSetupType === 3 &&
                                  this.state.showStopMessage
                              }
                              showConnectionLostMsg={this.state.showConnectionLostMsg}
                              sendUserIsWriting={this.sendUserIsWriting}
                              chatAgentMode={this.state.chatAgentMode}
                              integrationType={this.state.integrationType}
                              setSnackbarErrorMessage={this.setSnackbarErrorMessage}
                              handleRootClick={this.handleRootClick}
                              sendChatAgentIntent={this.sendChatAgentIntent}
                              flushTrainingPhraseList={() => this.flushTrainingPhraseList()}
                              disclaimer={ currentLanguage && currentLanguage.disclaimer}
                              chatInputText={currentLanguage && currentLanguage.chatInputText}
                              chatInputMax={this.state.chatConfig.chatInputMax}
                              message={this.state.chatInputMessage}
                              intent={this.state.intent}
                              isMenuTriggered={this.state.isMenuTriggered}
                              setIsMenuTriggered={this.setIsMenuTriggered}
                              reEnableMostAskedQuestions={this.reEnableMostAskedQuestions}
                              clearSpeechBubble={this.clearSpeechBubble}
                              toggleShowInfoPage ={this.toggleShowInfoPage}
                              setShowSearchBotChatField={(show) => this.setShowSearchBotChatField(show)}
                          />
                          </>
                      ) : (
                          <>
                            <ChatInput
                                uploadFileComplete={(file, callback) => this.uploadFileComplete(file, this.state.clientKey, callback)}
                                handleGetTrainingPhraseList={(text) => this.getTrainingPhraseList(text)}
                                handleGetChatResponse={(intentId) => this.getChatResponse(intentId)}
                                trainingPhraseList={this.state.trainingPhraseList}
                                botWriting={this.state.botWriting}
                                userWriting={this.state.userWriting}
                                chatConfig={this.state.chatConfig}
                                language={this.state.language}
                                sendMessage={this.sendMessage}
                                sendIntent={this.sendIntent}
                                stopMessage={this.stopMessage}
                                showStopMessage={this.state.chatConfig && this.state.chatConfig.gptSetupType == 3 && this.state.showStopMessage}
                                showConnectionLostMsg={this.state.showConnectionLostMsg}
                                sendUserIsWriting={this.sendUserIsWriting}
                                chatAgentMode={this.state.chatAgentMode}
                                integrationType={this.state.integrationType}
                                setSnackbarErrorMessage={this.setSnackbarErrorMessage}
                                handleRootClick={this.handleRootClick}
                                sendChatAgentIntent={this.sendChatAgentIntent}
                                flushTrainingPhraseList={() => this.flushTrainingPhraseList()}
                                disclaimer ={currentLanguage && currentLanguage.disclaimer}
                                chatInputText ={currentLanguage && currentLanguage.chatInputText}
                                chatInputMax ={this.state.chatConfig.chatInputMax}
                                message={this.state.chatInputMessage}
                                intent={this.state.intent}
                                isMenuTriggered={this.state.isMenuTriggered}
                                setIsMenuTriggered={this.setIsMenuTriggered}
                                reEnableMostAskedQuestions={this.reEnableMostAskedQuestions}
                                clearSpeechBubble={this.clearSpeechBubble}
                                fileUploadedText={this.state.fileUploadedText}
                                setShowSearchBotChatField={(show) => this.setShowSearchBotChatField(show)}
                                speechBubbleList={this.state.speechBubbleList}



                            />
                            <SearchBotChatField
                                token={this.state.token}
                                loadMore={this.state.loadMore}
                                loadToEnd={this.state.loadToEnd}
                                loadMoreSpeechBubble={this.loadMoreSpeechBubble}
                                speechBubbleList={this.state.speechBubbleList}
                                botWriting={this.state.botWriting}
                                userWriting={this.state.userWriting}
                                chatConfig={this.state.chatConfig}
                                sendMessage={this.sendMessage}
                                sendIntent={this.sendIntent}
                                welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                                sendChatResponseFeedback={this.sendChatResponseFeedback}
                                spectatorMode={this.state.userId != null}
                                language={this.state.language}
                                currentLanguage={currentLanguage}
                                onMenuItemClick={this.handleMenuItemClick}
                                sendMostAskedQuestions={this.sendMostAskedQuestions}
                                ref={this.searchBotFieldRef}
                                resizeChatContainer={this.resizeChatContainer}
                                sourcesList={this.state.sourcesList}
                                languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                    this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                languageSelected={this.languageSelected}
                                showSearchBotChatField={this.state.showSearchBotChatField}
                                toggleShowInfoPage ={this.toggleShowInfoPage}
                                setShowSearchBotChatField={(show) => this.setShowSearchBotChatField(show)}
                            />
                          </>
                      )}

                    </div>
                    :
                    <div id={'chat-bot-layout'} style={this.props.spectatorMode ? chatFieldSpectatorStyle : null}>

                      {this.state.userId == null ?
                          <Fragment>
                            <div id={'top-bar-shade'} style={{opacity: this.props.welcomePreviewEnabled ? '0.3' : null}}/>

                            <div id={'top-bar-container'} style={{display: this.props.welcomePreviewEnabled ? 'none' : null}}>
                              <TopBar language={this.state.language} showInfo ={this.state.chatConfig && !this.state.chatConfig.showLogoTop}
                                      avatar ={this.state.chatConfig && this.state.chatConfig.logoUrl} name={this.state.chatConfig && this.state.chatConfig.chatbotName}
                                      font={this.state.chatConfig && this.state.chatConfig.font}
                                      color={this.state.chatConfig && this.state.chatConfig.topFontColor}
                                      backgroundColor={this.state.chatConfig && this.state.chatConfig.topBackgroundColor}
                                      languageList={this.state.chatConfig && this.state.chatConfig.chatConfigLanguageList ?
                                          this.state.chatConfig.chatConfigLanguageList.map(ccl => ccl.language) : null}
                                      languageSelected={this.languageSelected} clientDescription={ this.state.chatConfig && this.state.chatConfig.clientDescription}
                                      enableMaximize={this.state.chatConfig.enableMaximize}  isMaximized ={this.state.isMaximized}  toggleMaxiChatbot ={this.toggleMaxiChatbot} closeChatbot ={this.closeChatbot}  toggleShowInfoPage={this.toggleShowInfoPage} welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                              />
                            </div>
                          </Fragment>
                          : null
                      }

                      <ChatBotChatField token={this.state.token}
                                        loadMore={this.state.loadMore}
                                        loadToEnd={this.state.loadToEnd}
                                        loadMoreSpeechBubble={this.loadMoreSpeechBubble}
                                        speechBubbleList={this.state.speechBubbleList}
                                        botWriting={this.state.botWriting}
                                        userWriting={this.state.userWriting}
                                        chatConfig={this.state.chatConfig}
                                        sendMessage={this.sendMessage}
                                        sendIntent={this.sendIntent}
                                        welcomePreviewEnabled={this.state.welcomePreviewEnabled}
                                        sendChatResponseFeedback={this.sendChatResponseFeedback}
                                        spectatorMode={this.state.userId != null}
                                        language={this.state.language}
                                        pendingFileUrls={this.state.pendingFileUrls}
                                        fileUploadedList={this.state.fileUploadedList}
                      />

                      {this.state.userId == null || this.state.chatAgentMode === true ?
                          <ChatInput
                              uploadFileComplete={(file, callback) => this.uploadFileComplete(file, this.state.clientKey, callback)}
                              handleGetTrainingPhraseList={(text) => this.getTrainingPhraseList(text)}
                              handleGetChatResponse={(intentId) => this.getChatResponse(intentId)}
                              trainingPhraseList={this.state.trainingPhraseList}
                              botWriting={this.state.botWriting}
                              userWriting={this.state.userWriting}
                              chatConfig={this.state.chatConfig}
                              language={this.state.language}
                              sendMessage={this.sendMessage}
                              sendIntent={this.sendIntent}
                              stopMessage={this.stopMessage}
                              showStopMessage={this.state.showStopMessage}
                              showConnectionLostMsg={this.state.showConnectionLostMsg}
                              sendUserIsWriting={this.sendUserIsWriting}
                              chatAgentMode={this.state.chatAgentMode}
                              integrationType={this.state.integrationType}
                              setSnackbarErrorMessage={this.setSnackbarErrorMessage}
                              handleRootClick={this.handleRootClick}
                              sendChatAgentIntent={this.sendChatAgentIntent}
                              flushTrainingPhraseList={() => this.flushTrainingPhraseList()}
                              disclaimer ={currentLanguage && currentLanguage.disclaimer}
                              chatInputText ={currentLanguage && currentLanguage.chatInputText}
                              chatInputMax ={this.state.chatConfig.chatInputMax}
                              pendingFileUrls={this.state.pendingFileUrls}
                              handleAddUploadedFiles={(name) => this.handleAddUploadedFiles(name)}
                              handleResetUploadedFiles={() => this.handleResetUploadedFiles()}
                              fileUploadedList={this.state.fileUploadedList}
                              handleDeleteUploadedFile={(index) => this.handleDeleteUploadedFile(index)}
                              fileUploadedListRemove={this.state.fileUploadedListRemove}
                              handleFlushDeleteUploadedFile={this.handleFlushDeleteUploadedFile}
                              chatAttachmentRef={this.chatAttachmentRef}
                              handleAddPendingFiles={(item) => this.handleAddPendingFiles(item)}
                              flushPendingFiles={this.flushPendingFiles}
                              pendingFiles={this.state.pendingFiles}
                              uploadFilesList={this.uploadFilesList}
                              fileUploadedText={this.state.fileUploadedText}
                              updateStateOfPlaceholder={this.updateStateOfPlaceholder}
                              speechBubbleList={this.state.speechBubbleList}

                          />
                          : null}
                    </div>
                }

              </Fragment> :

              <div id={'chat-loading-container'}>
                <CircularProgress/>
              </div>
          }

        </div>
    );
  }
}

export default Chat;
